export type AssetsTab = 'robots' | 'stations' | 'maintenance'

export function parseAssetsTab(raw: string | null | undefined): AssetsTab {
  const normalized = String(raw ?? '').trim().toLowerCase()
  if (normalized === 'stations') return 'stations'
  if (normalized === 'maintenance') return 'maintenance'
  return 'robots'
}
